var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWallet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 28,
    viewBox: "0 0 38 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_13490_28742",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 38,
    height: 28
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.3878 22.6502V23.0366C37.3878 23.2226 37.3878 23.3943 37.3878 23.5804C37.3878 23.7378 37.3878 23.8809 37.3878 24.0383C37.3878 24.3674 37.3592 24.7108 37.3019 25.0399C37.2447 25.369 37.1445 25.6839 36.9871 25.9844C36.8297 26.2849 36.6294 26.5567 36.4004 26.8C36.1572 27.0433 35.8853 27.2293 35.5848 27.3867C35.2843 27.5441 34.9695 27.6443 34.6404 27.7015C34.3113 27.7587 33.9678 27.7874 33.6387 27.7874C33.4813 27.7874 33.3382 27.7874 33.1808 27.7874C32.9948 27.7874 32.8231 27.7874 32.637 27.7874H30.5478H32.4939H5.50616H7.45226H5.36307C5.17705 27.7874 5.00533 27.7874 4.81931 27.7874C4.6619 27.7874 4.51881 27.7874 4.3614 27.7874C4.03228 27.7874 3.68885 27.7587 3.35973 27.7015C3.03061 27.6443 2.71581 27.5441 2.41531 27.3867C2.11481 27.2293 1.84292 27.029 1.59966 26.8C1.3564 26.5567 1.17038 26.2849 1.01297 25.9844C0.855567 25.6839 0.7554 25.369 0.698162 25.0399C0.640924 24.7108 0.612305 24.3674 0.612305 24.0383C0.612305 23.8809 0.612305 23.7378 0.612305 23.5804C0.612305 23.3943 0.612305 23.2226 0.612305 23.0366V22.7361V5.26415V7.05285V4.96365C0.612305 4.77763 0.612305 4.60592 0.612305 4.41989C0.612305 4.26249 0.612305 4.11939 0.612305 3.96199C0.612305 3.63287 0.640924 3.28944 0.698162 2.96032C0.7554 2.6312 0.855567 2.31639 1.01297 2.01589C1.17038 1.71539 1.37071 1.44351 1.59966 1.20025C1.84292 0.956987 2.11481 0.770963 2.41531 0.613558C2.71581 0.456153 3.03061 0.355986 3.35973 0.298748C3.68885 0.24151 4.03228 0.212891 4.3614 0.212891C4.51881 0.212891 4.6619 0.212891 4.81931 0.212891C5.00533 0.212891 5.17705 0.212891 5.36307 0.212891H7.45226H32.4939H32.637C32.8231 0.212891 32.9948 0.212891 33.1808 0.212891C33.3382 0.212891 33.4813 0.212891 33.6387 0.212891C33.9678 0.212891 34.3113 0.24151 34.6404 0.298748C34.9695 0.355986 35.2843 0.456153 35.5848 0.613558C35.8853 0.770963 36.1572 0.971297 36.4004 1.20025C36.6437 1.44351 36.8297 1.71539 36.9871 2.01589C37.1445 2.31639 37.2447 2.6312 37.3019 2.96032C37.3592 3.28944 37.3878 3.63287 37.3878 3.96199C37.3878 4.11939 37.3878 4.26249 37.3878 4.41989C37.3878 4.60592 37.3878 4.77763 37.3878 4.96365V5.35001V22.6645V22.6502Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_13490_28742)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.2286 1.35742H1.74268V25.3688H36.2286V1.35742Z",
    fill: "#DEDBCE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.8568 1.74512H2.14355V16.0547H35.8568V1.74512Z",
    fill: "#40A5D9"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_13490_28742)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.8567 7.82531C35.8567 7.71084 35.8567 7.59636 35.8567 7.48188C35.8567 7.38172 35.8567 7.28155 35.8567 7.19569C35.8567 6.98105 35.8424 6.76641 35.7994 6.56608C35.7565 6.35143 35.6993 6.1511 35.5991 5.96508C35.4989 5.77905 35.3701 5.60734 35.227 5.44993C35.0696 5.29253 34.8979 5.17805 34.7119 5.07788C34.5259 4.97772 34.3255 4.92048 34.1109 4.87755C33.8963 4.83462 33.6816 4.83462 33.4813 4.82031C33.3811 4.82031 33.2809 4.82031 33.1951 4.82031C33.0806 4.82031 32.9661 4.82031 32.8517 4.82031H32.7515H6.4935H5.16272C5.04824 4.82031 4.93376 4.82031 4.81929 4.82031C4.71912 4.82031 4.61895 4.82031 4.5331 4.82031C4.31845 4.82031 4.10381 4.83462 3.90348 4.87755C3.68883 4.92048 3.4885 4.97772 3.30248 5.07788C3.11645 5.17805 2.94474 5.30684 2.78733 5.44993C2.62993 5.60734 2.51545 5.77905 2.41529 5.96508C2.31512 6.1511 2.25788 6.35143 2.21495 6.56608C2.17202 6.78072 2.17202 6.99536 2.15771 7.19569C2.15771 7.29586 2.15771 7.39603 2.15771 7.48188C2.15771 7.59636 2.15771 7.71084 2.15771 7.82531V9.1561V8.11151V19.1155H35.871V7.82531H35.8567Z",
    fill: "#FFB003"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_13490_28742)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.8567 10.8878C35.8567 10.7733 35.8567 10.6589 35.8567 10.5444C35.8567 10.4442 35.8567 10.3441 35.8567 10.2582C35.8567 10.0436 35.8424 9.82891 35.7994 9.62858C35.7565 9.41393 35.6993 9.2136 35.5991 9.02758C35.4989 8.84155 35.3701 8.66984 35.227 8.51243C35.0696 8.35503 34.8979 8.24055 34.7119 8.14038C34.5259 8.04022 34.3255 7.98298 34.1109 7.94005C33.8963 7.89712 33.6816 7.89712 33.4813 7.88281C33.3811 7.88281 33.2809 7.88281 33.1951 7.88281C33.0806 7.88281 32.9661 7.88281 32.8517 7.88281H32.7515H6.4935H5.16272C5.04824 7.88281 4.93376 7.88281 4.81929 7.88281C4.71912 7.88281 4.61895 7.88281 4.5331 7.88281C4.31845 7.88281 4.10381 7.89712 3.90348 7.94005C3.68883 7.98298 3.4885 8.04022 3.30248 8.14038C3.11645 8.24055 2.94474 8.36934 2.78733 8.51243C2.62993 8.66984 2.51545 8.84155 2.41529 9.02758C2.31512 9.2136 2.25788 9.41393 2.21495 9.62858C2.17202 9.84322 2.17202 10.0579 2.15771 10.2582C2.15771 10.3584 2.15771 10.4585 2.15771 10.5444C2.15771 10.6589 2.15771 10.7733 2.15771 10.8878V12.2186V11.174V22.178H35.871V10.8878H35.8567Z",
    fill: "#40C740"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_13490_28742)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.8567 13.9493C35.8567 13.8349 35.8567 13.7204 35.8567 13.6059C35.8567 13.5057 35.8567 13.4056 35.8567 13.3197C35.8567 13.1051 35.8424 12.8904 35.7994 12.6901C35.7565 12.4755 35.6993 12.2751 35.5991 12.0891C35.4989 11.9031 35.3701 11.7314 35.227 11.574C35.0696 11.4166 34.8979 11.3021 34.7119 11.2019C34.5259 11.1017 34.3255 11.0445 34.1109 11.0016C33.8963 10.9586 33.6816 10.9586 33.4813 10.9443C33.3811 10.9443 33.2809 10.9443 33.1951 10.9443C33.0806 10.9443 32.9661 10.9443 32.8517 10.9443H32.7515H6.4935H5.16272C5.04824 10.9443 4.93376 10.9443 4.81929 10.9443C4.71912 10.9443 4.61895 10.9443 4.5331 10.9443C4.31845 10.9443 4.10381 10.9586 3.90348 11.0016C3.68883 11.0445 3.4885 11.1017 3.30248 11.2019C3.11645 11.3021 2.94474 11.4309 2.78733 11.574C2.62993 11.7314 2.51545 11.9031 2.41529 12.0891C2.31512 12.2751 2.25788 12.4755 2.21495 12.6901C2.17202 12.9047 2.17202 13.1194 2.15771 13.3197C2.15771 13.4199 2.15771 13.5201 2.15771 13.6059C2.15771 13.7204 2.15771 13.8349 2.15771 13.9493V15.2801V14.2355V25.2396H35.871V13.9493H35.8567Z",
    fill: "#F26D5F"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.097168 -0.301758V15.5389H2.14343V4.76382C2.14343 4.64934 2.14343 4.53486 2.14343 4.42039C2.14343 4.32022 2.14343 4.22005 2.14343 4.1342C2.14343 3.91955 2.15774 3.70491 2.20067 3.50458C2.2436 3.28993 2.30084 3.0896 2.401 2.90358C2.50117 2.71755 2.62995 2.54584 2.77305 2.38843C2.93045 2.23103 3.10217 2.11655 3.28819 2.01639C3.47422 1.91622 3.67455 1.85898 3.88919 1.81605C4.10384 1.77312 4.31848 1.77312 4.51881 1.75881C4.61898 1.75881 4.71915 1.75881 4.805 1.75881C4.91948 1.75881 5.03396 1.75881 5.14843 1.75881H6.47922H32.7372H32.8374C32.9519 1.75881 33.0663 1.75881 33.1808 1.75881C33.281 1.75881 33.3811 1.75881 33.467 1.75881C33.6816 1.75881 33.8963 1.77312 34.0966 1.81605C34.3113 1.85898 34.5116 1.91622 34.6976 2.01639C34.8836 2.11655 35.0554 2.24534 35.2128 2.38843C35.3702 2.54584 35.4846 2.71755 35.5848 2.90358C35.685 3.0896 35.7422 3.28993 35.7851 3.50458C35.8281 3.71922 35.8281 3.93386 35.8424 4.1342C35.8424 4.23436 35.8424 4.33453 35.8424 4.42039C35.8424 4.53486 35.8424 4.64934 35.8424 4.76382V6.0946V15.5389H37.8886V-0.301758H0.097168Z",
    fill: "#D9D6CC"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_13490_28742)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.4156 14.0078C28.2009 14.0078 27.972 14.0078 27.7573 14.0078C27.5713 14.0078 27.3853 14.0078 27.1993 14.0078C26.7986 14.0078 26.3836 14.0364 25.9973 14.108C25.5966 14.1795 25.2246 14.294 24.8525 14.48C24.8096 14.5086 23.7936 14.9666 22.8921 16.3689C22.2052 17.4421 20.8601 18.5726 18.9856 18.5726C17.1111 18.5726 15.766 17.4421 15.0791 16.3689C14.1204 14.8807 13.0328 14.4371 13.1187 14.48C12.7466 14.294 12.3746 14.1795 11.9739 14.108C11.5733 14.0364 11.1726 14.0078 10.7719 14.0078C10.5859 14.0078 10.3999 14.0078 10.2139 14.0078C9.99922 14.0078 9.77026 14.0078 9.55562 14.0078H0.111328V28.3173H37.9171V14.0078H28.4156Z",
    fill: "#DEDBCE"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_13490_28742",
    x: 1.37771,
    y: 3.79031,
    width: 35.2734,
    height: 15.8549,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.25
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.39
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.17 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_13490_28742"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_13490_28742",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_13490_28742",
    x: 1.37771,
    y: 6.85281,
    width: 35.2734,
    height: 15.8549,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.25
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.39
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_13490_28742"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_13490_28742",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_13490_28742",
    x: 1.37771,
    y: 9.91434,
    width: 35.2734,
    height: 15.8549,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.25
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.39
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.17 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_13490_28742"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_13490_28742",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_13490_28742",
    x: -0.668672,
    y: 12.9778,
    width: 39.3657,
    height: 15.8696,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.25
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.39
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_13490_28742"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_13490_28742",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/Wallet.12d0ae54743de734e9d51e3e099cc67e.svg";
export { ForwardRef as ReactComponent };